import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-full-anchor',
  templateUrl: './template-full-anchor.component.html',
  styleUrls: ['./template-full-anchor.component.scss']
})
export class TemplateFullAnchorComponent {
  @Input() container: string;
  @Input() mode = 'default';
  @Input() noPadding = false;
}
